// Module
var code = `<nav class="pager">
    <!--    <div class="pager__amount product-amount">-->
    <!--        <div class="product-amount__inner">-->
    <!--            <label>-->
    <!--                Toon-->
    <!--                <select>-->
    <!--                    <option>36</option>-->
    <!--                    <option value="1">72</option>-->
    <!--                    <option value="2">108</option>-->
    <!--                </select>-->
    <!--            </label>-->
    <!--        </div>-->
    <!--    </div>-->
    <div class="pagination-count">
        <span>Pagina <span data-bind="text: currentPage()"></span> van <span data-bind="text: totalPages()"></span></span>
    </div>
    
    <ul class="pagination">
        <!-- ko if: totalPages() !== 1 && currentPage() === 1-->
        <li class="pagination-item gotofirst disabled">
            <img src="/assets/icons/icon-arrowfirst-grey-12.svg" />
        </li>
        <!-- /ko -->
        <!-- ko if: currentPage() === 1-->
        <li class="pagination-item previous disabled">
            <img src="/assets/icons/icon-arrowback-grey-12.svg" />
        </li>
        <!-- /ko -->
        <!-- ko if: currentPage() > 1 -->
        <li data-bind="event:
                {click: \$root.gotoFirstPage}" class="pagination-item gotofirst">
            <img src="/assets/icons/icon-arrowfirst-darkgrey-12.svg" />
        </li>
        <li data-bind="event: {click: \$root.gotoPreviousPage}" class="pagination-item previous">
            <img src="/assets/icons/icon-arrowback-darkgrey-12.svg" />
        </li>
        <!-- /ko -->
        <li class="pagination-item first"
            data-bind="css: {'active': currentPage() == 1}, event: {click: \$root.gotoPage}">
            <span>1</span>
        </li>
        <!-- ko if: (currentPage() >= 4) -->
        <div class="pagination-item dots">
            <div class="dots__inner">...</div>
        </div>
        <!-- /ko -->
        <!-- ko foreach: pages  -->
        <li class="pagination-item"
            data-bind="css: {'active': \$parent.currentPage() == \$data}, event: {click: \$root.gotoPage}">
            <span data-bind="text: \$data"></span>
        </li>
        <!-- /ko -->
        <!-- ko if: (totalPages() - currentPage() >= 3) -->
        <div class="pagination-item dots">
            <div class="dots__inner">...</div>
        </div>
        <!-- /ko -->
        <!-- ko if: (totalPages() !== 1) -->
        <li class="pagination-item last" data-bind="css: {'active': currentPage() == totalPages()}, event: {click: \$root.gotoLastPage}">
            <span data-bind="text: totalPages()"></span>
        </li>
        <!-- /ko -->
        <!-- ko if: currentPage() !== totalPages() -->
        <li data-bind="event: {click: \$root.gotoNextPage}" class="pagination-item next">
            <img src="/assets/icons/icon-arrowforward-darkgrey-12.svg" />
        </li>
        <li data-bind="event: {click: \$root.gotoLastPage}" class="pagination-item gotolast">
            <img src="/assets/icons/icon-arrowlast-darkgrey-12.svg" />
        </li>
        <!-- /ko -->
        <!-- ko if: currentPage() === totalPages() -->
        <li class="pagination-item next disabled">
            <img src="/assets/icons/icon-arrowforward-grey-12.svg" />
        </li>
        <!-- /ko -->
        <!-- ko if: totalPages() !== 1 && currentPage() === totalPages()-->
        <li class="pagination-item gotolast disabled">
            <img src="/assets/icons/icon-arrowlast-grey-12.svg" />
        </li>
        <!-- /ko -->
    </ul>
</nav>
`;
// Exports
module.exports = code;